import { bool, func } from "prop-types"
import { css } from "@emotion/react"

const toggleStyles = {
  borderRadius: "16px",
  padding: "4px 8px",
  width: "72px",
  textAlign: "center",
  fontSize: "12px",
  border: "none",
  cursor: "pointer",
  transition: "all 0.1s linear",
  fontWeight: "500"
}

const PillToggle = ({ disabled, required, clickHandler, optionalOnly = false }) => {
  const optionalStyles = css({
    ...toggleStyles,
    backgroundColor: required ? "transparent" : "var(--color--neutral-600)",
    color: required ? "var(--color--neutral-600)" : "var(--color--white)"
  })

  const requiredStyles = css({
    ...toggleStyles,
    backgroundColor: required ? "var(--base-color)" : "transparent",
    color: required ? "var(--color--white)" : "var(--color--neutral-600)"
  })

  return (
    <div className="d-f ai-c">
      <button css={optionalStyles} disabled={disabled} onClick={clickHandler}>
        Optional
      </button>
      {!optionalOnly && (
        <button css={requiredStyles} disabled={disabled} onClick={clickHandler}>
          Required
        </button>
      )}
    </div>
  )
}

PillToggle.propTypes = {
  disabled: bool,
  required: bool,
  clickHandler: func,
  optionalOnly: bool
}

export default PillToggle
